import * as actionTypes from "./actionTypes";
import initialState from "reducers/initialState";
import * as eventTypes from "./eventTypes";

const documentWarrantyDataReducer = (state = initialState.document.warrantyData, action) => {
  switch (action.type) {
    case actionTypes.LOAD_WARRANTIES_DATA_STARTED: {
      return {
        ...state,
        warranty: {
          ...state.warranty,
          [action.id]: {
            ...state.warranty[action.id],
            loading: true,
            loaded: false
          }
        }
      };
    }
    case actionTypes.LOAD_WARRANTIES_DATA_SUCCESS: {
      return {
        ...state,
        warranty: {
          ...state.warranty,
          [action.id]: {
            loading: false,
            loaded: true
          }
        }
      };
    }
    case actionTypes.LOAD_WARRANTIES_SUMMARY_STARTED: {
      return {
        ...state,
        warrantySummary: {
          ...state.warrantySummary,
          [action.id]: {
            ...state.warrantySummary[action.id],
            loading: true,
            loaded: false
          }
        }
      };
    }
    case actionTypes.LOAD_WARRANTIES_SUMMARY_SUCCESS: {
      return {
        ...state,
        warrantySummary: {
          ...state.warrantySummary,
          [action.id]: {
            loading: false,
            loaded: true
          }
        }
      };
    }
    case actionTypes.LOAD_WARRANTIES_DATA_FAILED: {
      return {
        ...state,
        warranty: {
          ...state.warranty,
          [action.id]: {
            loading: false,
            loaded: false
          }
        }
      };
    }

    case eventTypes.WARRANTIES_INVALIDATED: {
      const { documentId, siteId } = action.event.eventBody;
      const key = `${documentId}-${siteId}`;

      return {
        ...state,
        warranty: {
          ...state.warranty,
          [key]: {
            loading: false,
            loaded: false
          }
        },
        warrantySummary: {
          ...state.warrantySummary,
          [key]: {
            loading: false,
            loaded: false
          }
        }
      };
    }

    default:
      return state;
  }
};

export default documentWarrantyDataReducer;
